"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformRequestModelStatus = void 0;
var SdPlatformRequestModelStatus;
(function (SdPlatformRequestModelStatus) {
    /** The model has been configured and shall be published. */
    SdPlatformRequestModelStatus["Done"] = "done";
    /** An error happened uploading the model. */
    SdPlatformRequestModelStatus["ErrorUpload"] = "error_upload";
})(SdPlatformRequestModelStatus = exports.SdPlatformRequestModelStatus || (exports.SdPlatformRequestModelStatus = {}));
//# sourceMappingURL=SdPlatformRequestModel.js.map